import type {LogoProps} from '@livingdata/playground-core-front'

export function GeopromptLogo({variant}: LogoProps) {
  if (variant === 'splash') {
    return <img src='/brand/logo.svg' alt='Geoprompt' style={{height: '12rem', maxWidth: '20rem'}} />
  }

  return <img src='/brand/logo-compact.png' alt='Geoprompt' className='h-full w-auto max-w-full' />
}
